import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ScenariosSection from './components/ScenariosSection';
import DownloadSection from './components/DownloadSection';
import ArticlesSection from './components/ArticlesSection';

const homeSEO = {
  title: '娜娜轻量版 — 轻盈体验，高效触达 | 官方站',
  description: '娜娜轻量版是专为追求极简高效体验用户打造的轻量化解决方案，体积小、启动快、功能精准。立即了解娜娜轻量版的核心优势、适用场景与下载使用指南，开启轻量新体验。',
  keywords: '娜娜轻量版,娜娜轻量版下载,娜娜轻量版功能介绍,娜娜轻量版使用教程,娜娜轻量版官方版,轻量版应用推荐',
  canonicalUrl: 'https://www.nanalite.com/',
};

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '娜娜轻量版',
    url: 'https://www.nanalite.com/',
    description: '娜娜轻量版是专为追求极简高效体验用户打造的轻量化解决方案。',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+86-400-888-9999',
      contactType: 'customer service',
      email: 'contact@nanalite.com',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '娜娜轻量版官方站',
    url: 'https://www.nanalite.com/',
    description: '娜娜轻量版官方网站 — 轻盈体验，高效触达',
    inLanguage: 'zh-CN',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '娜娜轻量版 — 首页',
    description: '娜娜轻量版官方首页，介绍产品核心功能与下载方式。',
    url: 'https://www.nanalite.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '娜娜轻量版官方站',
      url: 'https://www.nanalite.com/',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: '娜娜轻量版',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Windows, macOS, iOS, Android',
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'CNY',
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.9',
      ratingCount: '12580',
    },
  },
];

export default function Home() {
  return (
    <>
      <SEOHead
        title={homeSEO.title}
        description={homeSEO.description}
        keywords={homeSEO.keywords}
        canonicalUrl={homeSEO.canonicalUrl}
        ogTitle="娜娜轻量版 — 轻盈体验，高效触达"
        ogDescription="专为追求极简高效体验用户打造的轻量化解决方案。体积小、启动快、功能精准。"
        jsonLd={homeJsonLd}
      />
      <main>
        <HeroSection />
        <FeaturesSection />
        <ScenariosSection />
        <DownloadSection />
        <ArticlesSection />
      </main>
    </>
  );
}